<template>
<div v-show="visible && commandType" class="contextMenu" id="editorContextMenu" :style="{'left': `${posX}px`, 'top': `${posY}px`}"
  @contextmenu="browserContextMenuLock"
  ref="contextMenu"
>
  <ul>
    <template v-if="slctType == 'single'">
      <li v-show="commandType" v-if="!readonlyFlag" @click="modify">변경하기</li>
      <li v-show="commandType" v-if="!isVisualization" @click="callConnectProtocol">프로토콜 연결하기</li>
      <li v-show="commandType" @click="info">속성정보 보기</li>
      <li v-show="commandType" v-if="!readonlyFlag" @click="callEditAttribute">속성정보 편집</li>
      <li v-show="commandType" v-if="!readonlyFlag" @click="selectionDelete">선택한 태그 삭제</li>
    </template>
<!--    <template v-if="slctType == 'multiple'">
      <li v-show="commandType" @click="createGroupProcess('SUBPROCESS')">서브공정</li>
      <li v-show="commandType" @click="createGroupProcess('MAINPROCESS')">대표공정</li>
    </template>
    <template v-if="slctType == 'group'">
      <li v-show="commandType" @click="unGroup">대표/서브공정 해제</li>
    </template>-->
  </ul>
</div>
</template>

<script>
import { TagAddPopCommMapMutations } from "@TagAddPop/TagAddPopComm"; 
import AcListComm from '@AccordionList/AcListComm'; 
import { commNewMapGetters , commNewMapMutations , commNewMapActions } from "@processEditor/CommNew";
import { createNamespacedHelpers } from 'vuex';
import GO from "gojs";
import {v4} from "uuid";

const ProcessEditor = createNamespacedHelpers('ProcessEditor');
const Hub = createNamespacedHelpers('Hub');
const goMake = GO.GraphObject.make;

export default {
  mixins : [ AcListComm ] , 
  props : {
    slctType : {
      type : String , 
      default : 'single' , 
    } ,
    readonlyFlag : {
      type : Boolean ,
      default : false ,
    } ,
    isVisualization : {
      type : Boolean ,
      default : false ,
    } ,
  } , 
  data () {
    return {
      visible: false,
      contextMenu:{},
      posX:0, 
      posY:0,
      command: {},
      diagram: {},
      selectList: [],
      commandType: true,
      tagCommands: {},

      nodeLinkData : {},
    }
  },
  watch: {
    slctType ( slctType ) {
      console.log({ slctType })
    } ,
    getTagInfoCommand (value) {
      this.tagCommands = value
    }
  },
  created() {
    
  },
  mounted () {
    //console.log('context readonlyFlag = ',this.readonlyFlag)
    this.contextMenu = goMake(GO.HTMLInfo, {
      show: this.showContextMenu,
      hide: this.hideContextMenu,
    })
    this.$emit('contextMounted', this.contextMenu)
    // console.log({ slctType : this.slctType }) ; 
  },
  computed : {
    ...commNewMapGetters([
      'USER_INFO' , 
      'PROCESS_INFO' , 
    ]) , 
    ...ProcessEditor.mapGetters(['getTagInfoCommand']),
  },
  methods: {
    ...commNewMapActions([
      'addUseTags' , 
      'deleteUseTags' , 
    ]) , 
    ...commNewMapMutations([
      'setCrntDiagram' ,
      'updateStatus'
    ]),
    ...ProcessEditor.mapMutations(['selectNode']),
    ...TagAddPopCommMapMutations([
      'setTagOptionPopAddListViewBln' , 
      'setCrntTagType' , 
      'setCallbackFunc' , 
    ]) ,
    ...Hub.mapMutations(
        [
          "setEditAttributePopFlag",
          "setConnectProtocolObj"
        ]
    ),
    ...Hub.mapActions(
        [
          "updateSelectedNode",
          "fetchCheckProcessProp"
        ]
    ),
    nodesSortHandler ( direction ) {
      const [ arrLocX , arrLocY ] = [[] , []] ; 

      this.diagram.selection.iterator.each(( node ) => {
        arrLocX[ arrLocX.length ] = node.location.x ; 
        arrLocY[ arrLocY.length ] = node.location.y ; 

        console.log({
          node , 
        })
      }) ; 

      const [ minX , maxX , minY , maxY ] = [ 
        Math.min( ...arrLocX ) , 
        Math.max( ...arrLocX ) , 
        Math.min( ...arrLocY ) , 
        Math.max( ...arrLocY ) 
      ] ; 
      const centerX = maxX - (( maxX - minX ) / 2) ; 
      const middleY = maxY - (( maxY - minY ) / 2) ; 

      if ( direction == 'equal horizontal spacing' ) { // 가로 간격 동일 
        const distributeX = ( maxX - minX ) / this.diagram.selection.size ; 
        console.log({ distributeX }) ; 

        let idx = 0 ; 
        this.diagram.selection.iterator.each(( node ) => {
          let posX = minX + ( distributeX * idx ) ; 
          let posY = node.location.y ; 
          node.location = new go.Point( posX , posY ) ; 
          idx += 1; 
        }) ; 
        this.clearContextMenu() ; 
        return ; 
      }

      if ( direction == 'equal vertical spacing' ) { // 세로 간격 동일 
        const distributeY = ( maxY - minY ) / this.diagram.selection.size ; 

        let idx = 0 ; 
        this.diagram.selection.iterator.each(( node ) => {
          let posX = node.location.x ; 
          let posY = minY + ( distributeY * idx ) ; 
          node.location = new go.Point( posX , posY ) ; 
          idx += 1; 
        }) ; 
        this.clearContextMenu() ;  
        return ; 
      }
      
      
      this.diagram.selection.iterator.each(( node ) => {
        let posX = node.location.x ; 
        let posY = node.location.y ; 

        switch ( direction ) {
          case 'top'    : posY = minY ; break ; 
          case 'right'  : posX = maxX ; break ; 
          case 'bottom' : posY = maxY ; break ; 
          case 'left'   : posX = minX ; break ; 
          case 'center' : posX = centerX ; break ; 
          case 'middle' : posY = middleY ; break ; 
        }

        node.location = new go.Point( posX , posY ) ; 
      }) ; // end of this.diagram.selection.iterator.each

      this.clearContextMenu() ; 
    } , // end of nodesSortHandler 

    browserContextMenuLock (e) {
      e.preventDefault();
      return false;
    },
    showContextMenu (obj, diagram, tool) {
      this.nodeLinkData = {};
      let viewportBounds, contextSize
      let {x, y} = diagram.lastInput.viewPoint
      let scale = diagram.scale
      this.selectList = []
      this.diagram = diagram
      this.command = diagram.commandHandler
      this.setCrntDiagram( diagram ) ; 
      // console.log( "context", obj )
      if( !obj ) return;

      this.diagram.selection.each( (item)=>{
        this.selectList.push(item);
      } )
      if(this.selectList.length === 0) this.commandType = false
      else this.commandType = true

      viewportBounds = this.diagram.viewportBounds
      this.$refs.contextMenu.style.visibility = 'hidden' ; 
      this.visible = true

      setTimeout(_=>{
        contextSize = this.$refs.contextMenu.getBoundingClientRect()

        this.posX = Math.min( viewportBounds.width*scale - contextSize.width - 10, x ) ; 
        this.posY = Math.min( viewportBounds.height*scale - contextSize.height - 10, y) ; 
        this.$refs.contextMenu.style.visibility = 'visible' ; 

        // console.log({ 
        //   posY : this.posY , 
        //   height : contextSize.height , 
        // }) ; 
      }) ;
    },

    hideContextMenu (obj, diagram, tool) {
      // console.log('Hide context menu')
      this.visible = false
    },
    clearContextMenu () {
      if (this.diagram.currentTool instanceof go.ContextMenuTool) {
        this.diagram.currentTool.doCancel();
      }
      this.visible = false
    },

    tagChangeHandler ( tagInfo ) {
      let crntNode = this.selectList[0].data ; 
      this.diagram.model.commit( m => {
        let { nodeDataArray } = m ; 
        let modifyNode = null ; 
        nodeDataArray.filter( node => {
          if ( crntNode.category == node.category && crntNode.key == node.key ) {
            modifyNode = node ; 
          }
        }) ; 
        let { tagShape , id , name , tagType, newKey } = tagInfo ;

        const useTag = {
          id , 
          idUser : this.USER_INFO.id , 
          name , 
          tagShape : tagShape , 
          tagType , 
        } ; 
        // console.log( 'modifyNode : ' , modifyNode ) ; 
        this.deleteUseTags({ category : modifyNode.category , id : modifyNode.tagId }) ; 
        this.addUseTags({ category : tagType , useTag }) ; 

        m.setDataProperty( modifyNode , 'shape' , tagShape ) ; 
        m.setDataProperty( modifyNode , 'tagId' , id ) ; 
        m.setDataProperty( modifyNode , 'text' , name ) ;
        m.setDataProperty( modifyNode , 'key' , newKey ) ;
      }, "flash");
    } , 
    async modify () {
      const nodeData = this.selectList[0].data;
      
      //공정도 속성이 존재하는 경우 사전 변경 불가!
      const processPropsLength = await this.fetchCheckProcessProp({key: nodeData.key, processId: this.$route.query.processId}); 
      if(processPropsLength > 0){
        await window.alert("속성이 존재하는 경우, 동일 사전 내에서만 표시어를 변경할 수 있습니다.<br/>다른 사전으로 변경하려면 노드 삭제 후 새로 생성해 주세요.");
        const searchData = {
          tagId: nodeData.tagId
          , category: nodeData.category
          , key: nodeData.key
          , changeOnlyDisplayWord: true
        };
        this.$emit("callOpenDictionaryPopup", searchData, this.tagChangeHandler);
        this.clearContextMenu()
      }else{
        const searchData = {
          tagId: nodeData.tagId
          , category: nodeData.category
          , key: nodeData.key
          , changeOnlyDisplayWord: false
        };
        this.$emit("callOpenDictionaryPopup", searchData, this.tagChangeHandler);
        this.clearContextMenu()
      }
    },
    copy () {
      console.log('Copy : ')
      this.command.copySelection()
      this.clearContextMenu()
      // console.log( 'this.command : ' , this.command ) ; 
    },
    cut () {
      console.log('Cut : ', this.command.canCutSelection())
      this.command.cutSelection()
      this.clearContextMenu()
    },
    paste () {
      this.command.pasteSelection(
        this.diagram.toolManager.contextMenuTool.mouseDownPoint
      )
      this.clearContextMenu()
      console.log('Paste : ')
    },
    async selectionDelete () {
      const flag = await confirm("노드 삭제 시 입력된 실험입력데이터와 적용속성은 복구가 불가능합니다.\n 삭제하시겠습니까?");
      if(!flag)return;
      this.diagram.commandHandler.deleteSelection();
      this.clearContextMenu();
      console.log('delete : ');
    },
    info () {
      const nodeData = this.selectList[0].data;
      nodeData.visible = true
      this.selectNode(nodeData);
      this.clearContextMenu()
    },
    memo () {
      
    },

    createGroupProcess(gbn){
        const categoryCond = (gbn === "MAINPROCESS") ? ["PROCESS"] : ["PROCESS","MATERIAL"]
        let returnFlag = false;
        let keyArr = [];

        //select 한 노드 검증
        const selectedNodes = this.diagram.selection;
        selectedNodes.each((node)=>{
            //선택한 노드들은 공정이어야 함.
            if(node.data.category!=='PROCESS'){
                returnFlag = true;
            }
            keyArr.push(node.data.key);
        });

        if(!this.createGroupValidation(gbn,returnFlag,selectedNodes.count)){
          this.cancelGroupProcess();
          return;
        }
        //그룹화 대상
        let groupTargetNodes = [];
        let tempTargetNodes = new go.Set();
        let searchStartNode = null;

        // 재귀 함수를 사용한 하위 노드 탐색.
        function findBetweenNodes(selectedNode){
            let nodes = selectedNode.findNodesOutOf();
            nodes.each(function (node) {
                let targetNode = node;
                //console.log(`node.data.text : ${node.data.text} , node.data.key : ${node.data.key}`);

                if(keyArr.includes(targetNode.data.key)){
                    tempTargetNodes.add(searchStartNode);
                    tempTargetNodes.add(targetNode);
                    groupTargetNodes = [...groupTargetNodes,...tempTargetNodes.toArray()]
                    return;
                }

                if(categoryCond.includes(targetNode.data.category)){
                    tempTargetNodes.add(targetNode);
                    findBetweenNodes(targetNode);
                }else{
                    return;
                }
            });
            tempTargetNodes.clear()
            return;
        }

        selectedNodes.each((node)=>{
            if(groupTargetNodes.length > 0)return;
            searchStartNode = node;
            findBetweenNodes(node);
        });

        if(groupTargetNodes.length >= 3){
            //this.diagram.clearSelection();
            let subProcessFlag = false;
            groupTargetNodes.forEach(function(node) {
                //node.isSelected = true;
                if(node.data.category === 'MATERIAL'){
                  subProcessFlag = true;
                }
            });

            if(!subProcessFlag && gbn === "SUBPROCESS"){
              alert("서브공정에는 재료가 포함되어야 합니다.")
              this.cancelGroupProcess();
              return;
            }

            // 그룹 생성 시 사용할 archetypeGroupData 설정
            this.diagram.commandHandler.archetypeGroupData = {
                text: (gbn === "MAINPROCESS")?"대표공정":"서브공정",
                isGroup: true,
                color: "black",
                category: (gbn === "MAINPROCESS")?"MAINPROCESS":"SUBPROCESS",
                key : v4(),
                tagKey : v4(),
            };
            this.diagram.selectCollection(groupTargetNodes);
            this.diagram.model.commit( (m)=>{
              this.diagram.commandHandler.groupSelection();
            },"createGroupProcess");
        }else{
          alert('잘못된 연결입니다. 다시 확인해주세요.')
          this.cancelGroupProcess();
        }
    },

    cancelGroupProcess(){
      this.diagram.clearSelection();
      this.commandType = false
    },

    createGroupValidation(gbn, returnFlag, nodeCount){
        if(returnFlag && gbn === 'MAINPROCESS'){
            alert('대표공정 생성 시 공정만 선택해주세요.')
            return false;
        }

        if(nodeCount !== 2 && gbn === 'MAINPROCESS'){
            alert('대표공정 생성 시 시작공정과 끝공정을 선택해주세요.')
            return false;
        }

        if(returnFlag && gbn === 'SUBPROCESS'){
            alert('서브공정 생성 시 공정만 선택해주세요.')
            return false;
        }

        if(nodeCount !== 2 && gbn === 'SUBPROCESS'){
            alert('서브공정 생성 시 시작공정과 끝공정을 선택해주세요.')
            return false;
        }
        return true;
    },
    unGroup(){
        this.diagram.commandHandler.ungroupSelection();
        this.cancelGroupProcess();
    },
    async callEditAttribute(){
      this.updateStatus({ nodeinfoViewBln : false }) ;
      this.selectNode({}, false);

      const nodeData = this.selectList[0].data;
      console.log('[contextMenu.vue]callEditAttribute nodeData=',nodeData)
      const response = await this.$wApi.dictionary.getDictionaryKeyLinkByProcessIdAndKey({
        key: nodeData.key,
        processId: this.$route.query.processId
      });
      await this.updateSelectedNode({
        node : nodeData,
        dictionaryKeyLinkId : response.id,
        dictionaryId : response.dictionaryId,
        processId : this.$route.query.processId,
        key: nodeData.key
      });
    },
    callConnectProtocol(){
      const nodeData = this.selectList[0].data;
      /*console.log('[contextMenu.vue]callConnectProtocol nodeData=',nodeData)*/
      this.setConnectProtocolObj({
        openFlag: true,
        dataObj: {
          ...nodeData
        }
      })
    }
  }
}
</script>

<style lang="scss">
.contextMenu {
  position: absolute; top: 0; left:0;
  min-width: 135px;
  z-index: 10;
  background-color: #fff;;
  cursor: pointer;
  ul {
    padding: 8px;
    border: 1px solid #999;
    li {
      padding: 8px;
      font-size: 14px;
      @include text-prt-sb;
      column-gap: 8px; 
      &:hover {
        background: #eee;
      }

      display: flex; 
      align-items: center; 

      i.sort {
        display: flex; 
        width: 16px; height: 16px; 
        background-position: center center; 
        background-repeat: no-repeat; 

        &.top { background-image: url('@/assets/icons/align_vertical_top.svg'); }
        &.right { background-image: url('@/assets/icons/align_horizontal_right.svg'); }
        &.bottom { background-image: url('@/assets/icons/align_vertical_bottom.svg'); }
        &.left { background-image: url('@/assets/icons/align_horizontal_left.svg'); }
        &.center { background-image: url('@/assets/icons/align_horizontal_center.svg'); }
        &.middle { background-image: url('@/assets/icons/align_vertical_center.svg'); }
        &.center-distribute { background-image: url('@/assets/icons/align_horizontal_distribute.svg'); }
        &.middle-distribute { background-image: url('@/assets/icons/align_vertical_distribute.svg'); }
        
      } // end of i.sort 
    }
  }
}
</style>